import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import style from '../utils/styles'
import { rhythm } from '../utils/typography'

import sidebarShadow from '../assets/sidebar_shadow.png'

export const Site = styled.div`
`
export const Container = styled.div`
  width: 1080px;
  max-width: 90%;
  margin: 0 auto;
`

export const Content = styled.div`
  display: flex;
  flex-flow: column-reverse;
  width: 100%;

  @media (min-width: 800px) {
    flex-flow: row;
  }
`

export const Main = styled.div`
  display: flex;
  flex-grow: 1;
  flex-flow: column;

  @media (min-width: 800px) {
    flex-flow: ${props => props.column ? 'column' : 'row'}
  }
`
export const Row = Main.extend`

`
export const Col2 = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  margin-bottom: ${rhythm(1)};

  @media (min-width: 800px) {
    width: ${props => props.full ? '100%' : `calc(50% - ${rhythm(0.25)})`};
  }
`

export const Title = styled.h3`
  font-size: ${props => props.small ? rhythm(0.6) : rhythm(1.25)};
  text-align: center;
  position: relative;
  text-transform: uppercase;
  padding: ${rhythm(0.75)};
  width: auto;
  margin-left: auto;
  margin-right: auto;
  display: inline-block;

  @media (max-width: 400px) {
    word-wrap: break-word;
    word-break: break-all;
  }


  &::after {
    content: '';
    display: block;
    width: 50%;
    height: 2px;
    background: ${style.green};
    margin-left: 25%;
    margin-top: ${rhythm(0.25)};
  }
`
export const TitleH1 = Title.withComponent('h1').extend`
  font-size: ${rhythm(0.5)};
  @media (max-width: 400px) {
    word-wrap: break-word;
    word-break: break-all;
  }


  @media (min-width: 800px) {
    font-size: ${rhythm(1.35)};
  }
`

export const Sidebar = styled.div`
  display: flex;
  flex-flow: column;
  padding-bottom: ${rhythm(2)};
  margin-bottom: ${rhythm(2)};


  @media (min-width: 800px) {
    width: 30%;

    ${props => props.right && `
      background: url(${sidebarShadow}) left top no-repeat;
      margin-left: ${rhythm(0.25)};
      padding-left: ${rhythm(1)};
    `}
    ${props => props.right && `
      margin-right: ${rhythm(0.25)};
      padding-right: ${rhythm(1)};
    `}
  }
`

export const SidebarNews = styled.div`

  & .date {
    color: ${style.green};
    margin: 0;
  }

  & .news-p {
    margin-bottom: ${rhythm(0.25)};
  }

  & .news-link {
    color: ${style.green};
    font-style: italic;
    margin-bottom: ${rhythm(1)};
    display: inline-block;
  }

`

export const InfoBlock = Col2.extend`

  & .content-info {
    border: 1px solid #e7e7e7;
    padding: ${rhythm(0.25)};
    margin-bottom: ${rhythm(1)};
    ${props => props.isGray && `
      background: #f8f8f8;
    `}
  }

  &:first-child {
    margin-right: ${rhythm(0.5)};
  }

`

export const PageTop = styled.div`
  text-align: center;

  & p {
    font-style: italic;
    font-size: ${rhythm(1)};
    color: black;
  }

`




// WEBPACK FOOTER //
// ./src/layouts/layouts.js